import React from 'react';

interface ProgressBarProps {
  value: number;       // 0–100
  label?: string;
  showPercent?: boolean;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ value, label, showPercent = true }) => (
  <div style={{ marginBottom: 16 }}>
    {(label || showPercent) && (
      <div
        style={{
          display: 'flex', justifyContent: 'space-between',
          fontSize: '0.78rem', color: 'var(--text-muted)',
          fontFamily: 'var(--font-mono)', marginBottom: 6,
        }}
      >
        {label && <span>{label}</span>}
        {showPercent && <span>{Math.round(value)}%</span>}
      </div>
    )}
    <div
      style={{
        height: 6, background: 'var(--surface2)',
        borderRadius: 3, overflow: 'hidden',
      }}
    >
      <div
        style={{
          height: '100%',
          width: `${value}%`,
          background: 'linear-gradient(90deg, var(--accent), var(--accent2))',
          borderRadius: 3,
          transition: 'width 0.4s ease',
        }}
      />
    </div>
  </div>
);

export default ProgressBar;
